import React from "react"
import { Stack, Typography, TextField, MenuItem, RadioGroup, Radio, FormControl, FormLabel, FormControlLabel, ToggleButton, ToggleButtonGroup } from "@mui/material"
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs"
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers-pro"
import dayjs from "dayjs"

const DAY_ABBR = ['S', 'M', 'T', 'W', 'T', 'F', 'S']
const ordinal = (n) => { const s = ['th', 'st', 'nd', 'rd']; const v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]) }

const RecurrenceEditor = ({ form, setForm, startDate, onStartDateChange }) => (
    <Stack spacing={2} sx={{ mt: 1, p: 2, bgcolor: 'action.hover', borderRadius: 1 }}>
        <Typography variant="subtitle2">Recurrence Pattern</Typography>
        {onStartDateChange && (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker label="Start Date" value={startDate ? dayjs(startDate) : null} slotProps={{ textField: { size: 'small' } }}
                    onChange={v => v && onStartDateChange(v.format('YYYY-MM-DD'))} />
            </LocalizationProvider>
        )}
        <ToggleButtonGroup value={form.daysOfWeek} onChange={(e, val) => setForm(f => ({ ...f, daysOfWeek: val }))} size="small">
            {DAY_ABBR.map((label, i) => <ToggleButton key={i} value={i} sx={{ width: 36, fontSize: 12 }}>{label}</ToggleButton>)}
        </ToggleButtonGroup>
        <FormControl>
            <FormLabel sx={{ fontSize: 13 }}>Repeat</FormLabel>
            <RadioGroup row value={form.pattern} onChange={e => setForm(f => ({ ...f, pattern: e.target.value }))}>
                <FormControlLabel value="weekly" control={<Radio size="small" />} label="Weekly" />
                <FormControlLabel value="monthly" control={<Radio size="small" />} label="Monthly" />
            </RadioGroup>
        </FormControl>
        {form.pattern === 'weekly' && (
            <TextField select label="Every" value={form.interval} onChange={e => setForm(f => ({ ...f, interval: Number(e.target.value) }))} size="small">
                {[1, 2, 3, 4, 5, 6].map(n => <MenuItem key={n} value={n}>{n === 1 ? 'Every week' : `Every ${n} weeks`}</MenuItem>)}
            </TextField>
        )}
        {form.pattern === 'monthly' && (
            <RadioGroup value={form.monthlyMode} onChange={e => setForm(f => ({ ...f, monthlyMode: e.target.value }))}>
                <FormControlLabel value="dayOfMonth" control={<Radio size="small" />} label={
                    <Stack direction="row" spacing={1} alignItems="center">
                        <span>Day</span>
                        <TextField size="small" type="number" value={form.dayOfMonth} sx={{ width: 70 }} onChange={e => setForm(f => ({ ...f, dayOfMonth: Number(e.target.value) }))} slotProps={{ htmlInput: { min: 1, max: 31 } }} />
                        <span>of every month</span>
                    </Stack>
                } />
                <FormControlLabel value="weekOfMonth" control={<Radio size="small" />} label={
                    <Stack direction="row" spacing={1} alignItems="center">
                        <span>The</span>
                        <TextField select size="small" value={form.weekOfMonth} sx={{ width: 80 }} onChange={e => setForm(f => ({ ...f, weekOfMonth: Number(e.target.value) }))}>
                            {[1, 2, 3, 4, 5].map(n => <MenuItem key={n} value={n}>{ordinal(n)}</MenuItem>)}
                        </TextField>
                        <span>of selected days each month</span>
                    </Stack>
                } />
            </RadioGroup>
        )}
    </Stack>
)

export default RecurrenceEditor
